export default class notRequiredValidator {
    constructor() {
    }

    validate() {
        return true;
    }
}
